import { ReactNode, createContext, useMemo } from 'react'

export type Translator = (key: string, replacements?: string[], overrideLang?: string) => string

export type HasTranslation = (key: string) => boolean

export interface TranslationContextType {
  t: Translator
  hasTranslation: HasTranslation
}

export const TranslationContext = createContext<TranslationContextType>({
  t: key => key,
  hasTranslation: () => false,
})

export type TranslationProviderProps = {
  t: Translator
  children: ReactNode
  hasTranslation: HasTranslation
}

export function TranslationProvider(props: TranslationProviderProps) {
  const { t, children, hasTranslation } = props
  // Every row and cell in a list reads this context, and a fresh value object re-renders all of
  // them past their own React.memo — 1000 rows cost ~2.9 s in jsdom that way, ~0.05 s memoized.
  const value = useMemo(() => ({ t, hasTranslation }), [t, hasTranslation])
  return <TranslationContext.Provider value={value}>{children}</TranslationContext.Provider>
}
